export enum WasPatientImmobilizedConstants {
  SET_COLLAR = 'wasPatientImmobilized/SET_COLLAR',
  SET_CID = 'wasPatientImmobilized/SET_CID',
  SET_LBB = 'wasPatientImmobilized/SET_LBB',
  SET_KED = 'wasPatientImmobilized/SET_KED',
  SET_MAST = 'wasPatientImmobilized/SET_MAST',
  SET_PERFORMED_BY = 'wasPatientImmobilized/SET_PERFORMED_BY',
  SET_OUTCOME = 'wasPatientImmobilized/SET_OUTCOME',
  RESET_WAS_PATIENT_IMMOBILIED = 'wasPatientImmobilized/RESET_WAS_PATIENT_IMMOBILIED',
  SET_WAS_PATIENT_IMMOBILIED = 'wasPatientImmobilized/SET_WAS_PATIENT_IMMOBILIED',
  SAVE_WAS_PATIENT_IMMOBILIZED = 'wasPatientImmobilized/SAVE_WAS_PATIENT_IMMOBILIZED',
}
